import React from 'react';
import { JourneyPersona } from '../../types/journey';
import { useLanguage } from '../../context/LanguageContext';
import './PersonaBadge.css';

interface PersonaBadgeProps {
  persona: JourneyPersona;
  size?: 'small' | 'medium' | 'large';
  showDescription?: boolean;
}

export const PersonaBadge: React.FC<PersonaBadgeProps> = ({
  persona,
  size = 'medium',
  showDescription = false
}) => {
  const { t } = useLanguage();
  
  const getPersonaConfig = (persona: JourneyPersona) => {
    switch (persona) {
      case 'skilled-maker':
        return {
          icon: '🔧',
          color: '#3b82f6',
          bgColor: '#eff6ff',
          name: t('journey.personaSkilledMaker'),
          description: t('journey.personaSkilledMakerDesc')
        };
      case 'expert-service':
        return {
          icon: '📚',
          color: '#8b5cf6',
          bgColor: '#f5f3ff',
          name: t('journey.personaExpertService'),
          description: t('journey.personaExpertServiceDesc')
        };
      case 'founder-plan':
        return {
          icon: '🎯',
          color: '#f59e0b',
          bgColor: '#fffbeb',
          name: t('journey.personaFounderPlan'),
          description: t('journey.personaFounderPlanDesc')
        };
      default:
        return {
          icon: '🚀',
          color: '#6b7280',
          bgColor: '#f9fafb',
          name: persona,
          description: t('journey.personaDefaultDesc')
        };
    }
  };

  const config = getPersonaConfig(persona);

  return (
    <div className={`persona-badge ${size}`}>
      <div 
        className="persona-badge-content"
        style={{
          backgroundColor: config.bgColor,
          color: config.color,
          borderColor: config.color + '40'
        }}
      >
        <span className="persona-icon">{config.icon}</span>
        <span className="persona-name">{config.name}</span>
      </div>
      
      {showDescription && (
        <div className="persona-description">
          <p>{config.description}</p>
        </div>
      )}
    </div>
  );
};